import React from 'react'
import PropTypes from 'prop-types'

import { Box } from '@chatterbug/aaron'

// calculates top-padding based on aspect ratio --
// https://www.w3schools.com/howto/howto_css_aspect_ratio.asp)
export const getTopPadding = (aspectRatio) => {
  const [x, y] = aspectRatio
    .split(':')
    .map((el) => parseInt(el))
    .sort((a, b) => a - b)
  return `${(x / y) * 100}%`
}

const AspectRatioImage = ({
  imgUrl,
  aspectRatio = '16:9',
  children,
  altText,
  ...rest
}) => {
  return (
    <Box
      role="img"
      aria-label={altText}
      pt={getTopPadding(aspectRatio)}
      backgroundImage={`url(${imgUrl})`}
      backgroundSize="cover"
      backgroundRepeat="no-repeat"
      backgroundPosition="center"
      {...rest}
    >
      {children}
    </Box>
  )
}

AspectRatioImage.propTypes = {
  imgUrl: PropTypes.string.isRequired,
  aspectRatio: PropTypes.string,
  altText: PropTypes.string,
}

export default AspectRatioImage
